import axios from '@/axios'

function urlCreator(url, params) {
  let urlString = `${process.env.VUE_APP_API_URL}${url}`
  if (params) {
    urlString = new URL(`${process.env.VUE_APP_API_URL}${url}`)
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) urlString.searchParams.append(key, value)
    })
  }
  return urlString
}

// ---------------------------------------------------- Car management: Cars
export function getCarManagementCars(params) {
  return axios.get(urlCreator('carmanagement/cars/'), params)
}

// ---------------------------------------------------- Car management: Fuel logs
export function patchCarManagementFuelLogsEfdReceipts(id, data) {
  return axios.patch(urlCreator(`carmanagement/fuel-logs/${id}/efd-receipts/`), data)
}

// ---------------------------------------------------- Car management: Logs
export function getCarManagementFuelLogsDrivers(params) {
  return axios.get(urlCreator('carmanagement/fuel-logs/drivers/', params))
}

// ---------------------------------------------------- Transfers: Trips
export function getTransfersTrips(params) {
  return axios.get(urlCreator('transfers/trips/', params))
}

export function postTransfersTrips(data) {
  return axios.post(urlCreator('transfers/trips/'), data)
}

export function patchTransfersTrips(id, data) {
  return axios.patch(urlCreator(`transfers/trips/${id}/`), data)
}
// ---------------------------------------------------- Finance: Accounts
export function getFinanceAccountsCharge(params) {
  return axios.get(urlCreator('finance/accounts/charge/', params))
}

// ---------------------------------------------------- Finance: Invoices
export function getFinanceInvoices(params) {
  return axios.get(urlCreator('finance/invoices/', params))
}

export function patchFinanceInvoiceAuthData(invoice, data) {
  return axios.patch(`finance/invoices/auth-data-charge/${invoice}/`, data)
}

// ---------------------------------------------------- Finance: On site Payment
export function getFinancePaymentsOnSite(params) {
  return axios.get(urlCreator('finance/payments/on-site/', params))
}

export function postFinancePaymentsOnSite(data) {
  return axios.post(urlCreator('finance/payments/on-site/'), data)
}

// ---------------------------------------------------- Hotel Management: Transactions
export function getHotelManagementTransactions(params) {
  return axios.get(urlCreator('v2/hotel_management/transactions/pos/', params))
}

export function postHotelManagementTransaction(data) {
  return axios.post(urlCreator('v2/hotel_management/transactions/pos/'), data)
}

// ---------------------------------------------------- Clients: Clients
export function getClientSearch(params) {
  return axios.get(urlCreator('clients/search/', params))
}

// ---------------------------------------------------- Clients: Groups
export function getClientGroupsSearch(params) {
  return axios.get(urlCreator('clients/groups/search/', params))
}

// ---------------------------------------------------- Users
export function getMe() {
  return axios.get('users/me/')
}

export function getPersonalCabinetMe() {
  return axios.get('employees/personal-cabinet/me/')
}

export function getPersonalCabinetProfile() {
  return axios.get('employees/personal-cabinet/profile/')
}

export function getPersonalCabinetOverview() {
  return axios.get('employees/personal-cabinet/overview/')
}

export function getPersonalCabinetRequests(scope = 'all') {
  return axios.get('employees/personal-cabinet/requests/', { params: { scope } })
}

export function getPersonalCabinetNavigationStats() {
  return axios.get('employees/personal-cabinet/navigation-stats/')
}

export function getPersonalCabinetFeedback(params) {
  return axios.get('employees/personal-cabinet/feedback/', { params })
}

export function getPersonalCabinetFeedbackDetail(id) {
  return axios.get(`employees/personal-cabinet/feedback/${id}/`)
}

export function postPersonalCabinetFeedback(data) {
  return axios.post('employees/personal-cabinet/feedback/', data)
}

export function getPersonalCabinetPayslips(params) {
  return axios.get('employees/personal-cabinet/payslips/', { params })
}

export function getPersonalCabinetPayslipsSummary(params) {
  return axios.get('employees/personal-cabinet/payslips/summary/', { params })
}

export function downloadPersonalCabinetPayslip(id) {
  return axios.get(`employees/personal-cabinet/payslips/${id}/download/`)
}

export function getPersonalCabinetStaffLoans() {
  return axios.get('employees/personal-cabinet/staff-loans/')
}

export function getPersonalCabinetStaffLoanPreview(params) {
  return axios.get('employees/personal-cabinet/staff-loans/eligibility-preview/', { params })
}

export function postPersonalCabinetStaffLoan(data) {
  return axios.post('employees/personal-cabinet/staff-loans/', data)
}

export function cancelPersonalCabinetStaffLoan(id) {
  return axios.post(`employees/personal-cabinet/staff-loans/${id}/cancel/`, {})
}

export function getPersonalCabinetStaffLoanPdf(id) {
  return axios.get(`employees/personal-cabinet/staff-loans/${id}/payment-schedule-pdf/`)
}

export function getPersonalCabinetAdvances() {
  return axios.get('employees/personal-cabinet/advances/')
}

export function getPersonalCabinetAdvancePreview(params) {
  return axios.get('employees/personal-cabinet/advances/eligibility-preview/', { params })
}

export function postPersonalCabinetAdvance(data) {
  return axios.post('employees/personal-cabinet/advances/', data)
}

export function cancelPersonalCabinetAdvance(id) {
  return axios.post(`employees/personal-cabinet/advances/${id}/cancel/`, {})
}

export function getPersonalCabinetHeslbLoans() {
  return axios.get('employees/personal-cabinet/heslb-loans/')
}

export function getPersonalCabinetLeaveTypes(params) {
  return axios.get('employees/personal-cabinet/leave-types/', { params })
}

export function getPersonalCabinetLeaveRequests() {
  return axios.get('employees/personal-cabinet/leave-requests/')
}

export function postPersonalCabinetLeaveRequest(data) {
  return axios.post('employees/personal-cabinet/leave-requests/', data)
}

export function cancelPersonalCabinetLeaveRequest(id) {
  return axios.post(`employees/personal-cabinet/leave-requests/${id}/cancel/`, {})
}

export function patchPersonalCabinetLeaveAttachment(id, data) {
  return axios.patch(`employees/personal-cabinet/leave-requests/${id}/attachment/`, data)
}

export function getPersonalCabinetSourceDetail(source, id) {
  const endpoints = {
    advance: 'advances',
    staff_loan: 'staff-loans',
    leave: 'leave-requests',
  }
  if (source === 'idea' || source === 'misconduct') return getPersonalCabinetFeedbackDetail(id)
  return axios.get(`employees/personal-cabinet/${endpoints[source]}/${id}/`)
}

export function getMeDriver() {
  return axios.get('users/me/driver/')
}

// ---------------------------------------------------- Files
export function postFile(data) {
  return axios.post('files/', data)
}

// ---------------------------------------------------- Common
export function getNavStats() {
  return axios.get('common/nav/stats/')
}

// ---------------------------------------------------- api
export function login(data) {
  return axios.post('auth/jwt/create/', data)
}

export function requestPersonalCabinetPasswordReset(data) {
  return axios.post('employees/personal-cabinet/auth/password-reset/', data)
}

export function confirmPersonalCabinetPasswordReset(data) {
  return axios.post('employees/personal-cabinet/auth/password-reset/confirm/', data)
}

// ---------------------------------------------------- Integrations
export function getGoogleSearch(search) {
  return axios.get(`googlemaps/search/?Search=${search}`)
}

// ---------------------------------------------------- Dicts
export function postLocation(data) {
  return axios.post('dicts/locations/', data)
}

export function getBanks(params) {
  return axios.get(urlCreator('finance/dicts/banks/', params))
}

export function getCardTypes(params) {
  return axios.get(urlCreator('finance/dicts/credit-card-types/', params))
}
